import { enumDashStyle, enumFillMode } from "../constants";
import { QConnectingLine } from "./QConnectingLine";
import { QXMLObject } from "./QXMLObject";

export class QConnectingLineFormat extends QXMLObject {
  constructor() {
    super();
    this.fLineColor = "#000000";
    this.fLineThickness = 1;
    this.fFillMode = enumFillMode.solidFill;
    this.fDashStyle = enumDashStyle.nodash;
  }

  GetXMLElementName() {
    return "connectingline";
  }

  OutputSubElements(stream) {
    //this.OutputElementTriple("cl_props", this.fLineColor, this.fFillMode, this.fLineThickness, stream);
    this.OutputElementQuad(
      "cl_props2",
      this.fLineColor,
      this.fFillMode,
      this.fLineThickness,
      this.fDashStyle,
      stream
    );
  }

  LoadSubElements(objTree) {
    var newv = true;
    var valueList = objTree.GetValueListForChild("cl_props2", false);
    if (valueList == null) {
      valueList = objTree.GetValueListForChild("cl_props", false);
      newv = false;
    }

    this.fLineColor = valueList[0];
    this.fFillMode = parseInt(valueList[1]);
    this.fLineThickness = parseInt(valueList[2]);

    if (newv) this.fDashStyle = parseInt(valueList[3]);
  }

  LoadFromJSON(data) {
    this.fLineColor = data["color"];
    this.fFillMode = data["fillMode"];
    this.fLineThickness = data["thickness"];

    if (data["dash"]) this.fDashStyle = data["dash"];
  }

  Clone() {
    var c = new QConnectingLineFormat();

    c.fLineColor = this.fLineColor;
    c.fLineThickness = this.fLineThickness;
    c.fFillMode = this.fFillMode;
    c.fDashStyle = this.fDashStyle;

    return c;
  }

  RestoreProperties(srcLayout) {
    this.fLineColor = srcLayout.GetConnectingLineColor();
    this.fLineThickness = srcLayout.GetConnectingLineThickness();
    this.fFillMode = srcLayout.GetConnectingLineFillMode();
    this.fDashStyle = srcLayout.GetConnectorDashStyle();
  }

  // Mar29
  CompareProperties(srcLine) {
    if (this.fLineColor != srcLine.fLineColor) return false;

    if (this.fLineThickness != srcLine.fLineThickness) return false;

    if (this.fFillMode != srcLine.fFillMode) return false;

    if (this.fDashStyle != srcLine.fDashStyle) return false;

    return true;
  }

  GetConnectingLineColor() {
    return this.fLineColor;
  }

  SetConnectingLineColor(lineColor) {
    this.fLineColor = lineColor;
  }

  SetConnectingLineThickness(thickness) {
    this.fLineThickness = thickness;
  }

  GetConnectingLineThickness() {
    return this.fLineThickness;
  }

  SetConnectingLineFillMode(fillMode) {
    this.fFillMode = fillMode;
  }

  GetConnectingLineFillMode() {
    return this.fFillMode;
  }

  SetConnectorDashStyle(dashStyle) {
    this.fDashStyle = dashStyle;
  }

  GetConnectorDashStyle() {
    return this.fDashStyle;
  }
}
